import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PayCancel() {
  return (
    <div className="max-w-2xl mx-auto px-5 md:px-8 py-16 text-center">
      <div className="pl-card bg-[#FFE600] p-10">
        <h1 className="font-display text-4xl md:text-5xl tracking-tighter">No charge, pookie.</h1>
        <p className="font-mono-pl text-sm mt-3">You backed out before payment. Totally fine.</p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link to="/pricing" className="pl-btn pl-btn-primary">Try again</Link>
          <Link to="/" className="pl-btn pl-btn-ghost">
            <ArrowLeft size={16} strokeWidth={3} /> Back to court
          </Link>
        </div>
      </div>
    </div>
  );
}
